import { supabase } from './supabase';

export type SourceResourceType =
  | 'product'
  | 'variant'
  | 'product_image'
  | 'inventory_item'
  | 'inventory_level'
  | 'order'
  | 'order_line_item'
  | 'refund'
  | 'customer'
  | 'location';

export type SourceOperation = 'upsert' | 'delete' | 'redact';

export interface SourceRecord {
  source_type?: string;
  resource_type: SourceResourceType;
  external_id: string;
  operation?: SourceOperation;
  data: Record<string, unknown>;
  raw?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
  source_event_id?: string | null;
  source_updated_at?: string | null;
}

export interface IngestSourceRecordsResult {
  success: boolean;
  source_type: string;
  count: number;
  counts: Record<string, number>;
}

export class SourceIngestionError extends Error {
  code?: string;
  details?: string | null;
  hint?: string | null;

  constructor(error: { code?: string; details?: string | null; hint?: string | null; message?: string }) {
    super(error.message || 'Source ingestion failed');
    this.name = 'SourceIngestionError';
    this.code = error.code;
    this.details = error.details;
    this.hint = error.hint;
  }
}

export async function ingestSourceRecords(
  sourceType: string,
  records: SourceRecord[],
  context: Record<string, unknown> = {},
): Promise<IngestSourceRecordsResult> {
  if (records.length === 0) {
    return {
      success: true,
      source_type: sourceType,
      count: 0,
      counts: {},
    };
  }

  const { data, error } = await supabase.rpc('ingest_source_records', {
    p_source_type: sourceType,
    p_records: records,
    p_context: context,
  });

  if (error) {
    throw new SourceIngestionError(error);
  }

  return data as IngestSourceRecordsResult;
}
